import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce12da0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-who-we-are-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-who-we-are-image" }, null, -1))
const _hoisted_3 = { class: "home-who-we-are-note animate__animated animate__slideInRight" }
const _hoisted_4 = { class: "home-who-we-are-note-title" }
const _hoisted_5 = { class: "home-who-we-are-note-description" }
const _hoisted_6 = { class: "home-who-we-are-note-middle-main" }
const _hoisted_7 = { class: "home-who-we-are-note-description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "home-who-we-are-note-description" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "home-who-we-are-note-description" }
const _hoisted_12 = { class: "home-who-we-are-note-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("home.who-we-are.title")), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("home.who-we-are.description-1")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.who-we-are.subtitle")), 1)
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("home.who-we-are.description-2")), 1),
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("home.who-we-are.description-3")), 1),
      _hoisted_10,
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("home.who-we-are.description-4")), 1),
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("home.who-we-are.description-5")), 1)
    ])
  ]))
}